export default __webpack_public_path__ + "images/6R.d8f6106.png";